const RARITY = {
  Common: "text-slate-300 border-slate-500/40 bg-slate-500/10",
  Rare: "text-cyan-300 border-cyan-400/50 bg-cyan-400/10",
  Legendary: "text-[#FFC700] border-[#FFC700]/50 bg-[#FFC700]/10",
  Mythic: "text-fuchsia-300 border-[#8A2BE2]/70 bg-[#8A2BE2]/20",
};

export const RarityBadge = ({ rarity, className = "" }) => (
  <span className={`inline-flex items-center rounded-full border px-3 py-1 font-mono text-[0.62rem] uppercase tracking-[0.22em] ${RARITY[rarity] || RARITY.Common} ${className}`}
    data-testid="rarity-badge">
    {rarity}
  </span>
);

export const BiomeBadge = ({ biome }) => (
  <span className="inline-flex items-center rounded-full border border-white/15 bg-white/5 px-3 py-1 font-mono text-[0.62rem] uppercase tracking-[0.18em] text-slate-200" data-testid="biome-badge">
    {biome}
  </span>
);

export const hazardColor = (lvl) => (lvl <= 3 ? "#00FF66" : lvl <= 6 ? "#FFC700" : "#FF5500");

export const HazardMeter = ({ level, compact = false }) => (
  <div className="flex items-center gap-2" data-testid="hazard-meter" title={`Hazard ${level}/10`}>
    {!compact && <span className="label-mono">Hazard</span>}
    <div className="flex gap-[3px]">
      {Array.from({ length: 10 }).map((_, i) => (
        <span key={i} className="h-3 w-1.5 rounded-sm"
          style={{ background: i < level ? hazardColor(level) : "rgba(148,163,184,0.18)", boxShadow: i < level ? `0 0 6px ${hazardColor(level)}66` : "none" }} />
      ))}
    </div>
    <span className="font-mono text-xs" style={{ color: hazardColor(level) }}>{level}</span>
  </div>
);
